import { render, staticRenderFns } from "./BubbleChart.vue?vue&type=template&id=04a9fa64&scoped=true"
import script from "./BubbleChart.vue?vue&type=script&lang=js"
export * from "./BubbleChart.vue?vue&type=script&lang=js"
import style0 from "./BubbleChart.vue?vue&type=style&index=0&id=04a9fa64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a9fa64",
  null
  
)

export default component.exports